// config.js
export const proxyUrl = 'integration-proxy.rdrive.io';
export const apiUrl = 'uk.rdrive.io';
export const username = 'admin@rdrive.io';
export const password = '';
export const exportPath = '';
// Prefix for Installation Cost figures. The API does not report a currency, so
// this is a project-wide display choice.
export const currencySymbol = '$';
